import { StatusCard } from "../statusCard";

interface PlansGridProps {
  plansTotals: Record<string, number>;
  plansTooltips: Record<string, string>;
}

export function PlansGrid({ plansTotals, plansTooltips }: PlansGridProps) {
  return (
    <div className="mt-8 sm:mt-10">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center gap-2 text-black mb-4 sm:mb-6">
        <span>📊</span>
        Distribuição por Planos
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 min-h-[100px]">
        {Object.entries(plansTotals).map(([plano, total]) => (
          <StatusCard
            key={plano}
            title={plano}
            value={total}
            color="text-black"
            tooltip={plansTooltips[plano]}
          />
        ))}
      </div>
    </div>
  );
}
